import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-youtube';
export var ID = 'icon-youtube';
/* eslint-disable max-len */

export var SVGYoutube = function SVGYoutube() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 12"
  }, React.createElement("defs", null, React.createElement("polygon", {
    id: "path-1-youtube",
    points: "5.24590164e-05 0.128729302 15.932459 0.128729302 15.932459 11.52 5.24590164e-05 11.52"
  })), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-334.000000, -489.000000)"
  }, React.createElement("g", {
    transform: "translate(334.000000, 487.000000)"
  }, React.createElement("g", {
    transform: "translate(0.000000, 2.000000)"
  }, React.createElement("g", null, React.createElement("mask", {
    id: "mask-2-youtube",
    fill: "white"
  }, React.createElement("use", {
    xlinkHref: "#path-1-youtube"
  })), React.createElement("g", null), React.createElement("path", {
    d: "M15.5995279,1.9074307 C15.4163148,1.20725581 14.8763803,0.655903256 14.1908721,0.468770233 C12.9483803,0.128662326 7.96621639,0.128662326 7.96621639,0.128662326 C7.96621639,0.128662326 2.98405246,0.128662326 1.74156066,0.468770233 C1.05605246,0.655903256 0.516118033,1.20725581 0.332904918,1.9074307 C5.24590164e-05,3.17650605 5.24590164e-05,5.82436465 5.24590164e-05,5.82436465 C5.24590164e-05,5.82436465 5.24590164e-05,8.47222326 0.332904918,9.74116465 C0.516118033,10.4413395 1.05605246,10.992826 1.74156066,11.1799591 C2.98405246,11.520067 7.96621639,11.520067 7.96621639,11.520067 C7.96621639,11.520067 12.9483803,11.520067 14.1908721,11.1799591 C14.8763803,10.992826 15.4163148,10.4413395 15.5995279,9.74116465 C15.9325115,8.47222326 15.9325115,5.82436465 15.9325115,5.82436465 C15.9325115,5.82436465 15.9325115,3.17650605 15.5995279,1.9074307",
    fill: "#FF0000",
    mask: "url(#mask-2-youtube)"
  })), React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "6.4 8.32 10.24 5.76 6.4 3.2"
  }))))));
};
/* eslint-disable max-len */

var YouTube = function YouTube(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGYoutube
  });
};

YouTube.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default YouTube;